import { finitePercent } from './reportMarket'

export function parseStockRows(text) {
  const pattern = /([^\s[\]()（）<>，,;；:：]+)\s*[（(](\d{6})[)）](?:\s*([+-]?\d+(?:\.\d+)?%))?/g
  const matches = Array.from(text.matchAll(pattern))
  const clean = value => value.replace(/^[\s[\]，,;；:：、-]+|[\s[\]，,;；、-]+$/g, '').trim()
  return {
    notes: clean(matches.length ? text.slice(0, matches[0].index) : text),
    rows: matches.map((match, index) => ({
      name: match[1].replace(/^[-•·]+/, ''), code: match[2],
      originalPct: match[3] ? finitePercent(match[3].slice(0, -1)) : null,
      description: clean(text.slice(match.index + match[0].length, matches[index + 1] ? matches[index + 1].index : text.length))
    }))
  }
}

export function extractReportStockTables(html) {
  const container = document.createElement('div')
  container.innerHTML = html
  const markers = Array.from(container.querySelectorAll('.stock-badge, .other-badge'))
  if (!markers.length) return { html, groups: [] }
  const groups = markers.map((marker, index) => {
    const range = document.createRange()
    range.setStartAfter(marker)
    if (markers[index + 1]) range.setEndBefore(markers[index + 1])
    else range.setEnd(container, container.childNodes.length)
    const body = document.createElement('div')
    body.appendChild(range.cloneContents())
    body.querySelectorAll('br').forEach(br => br.replaceWith(document.createTextNode('\n')))
    return { title: marker.classList.contains('stock-badge') ? '核心标的' : '其他标的', ...parseStockRows(body.textContent) }
  })
  if (!groups.some(group => group.rows.length)) return { html, groups: [] }
  const stockContent = document.createRange()
  stockContent.setStartBefore(markers[0])
  stockContent.setEnd(container, container.childNodes.length)
  stockContent.deleteContents()
  return { html: container.innerHTML, groups }
}
